const NO_DATA_MESSAGE = "データが見つかりません。";

export default NO_DATA_MESSAGE;
